import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authService } from '../../services/authService';
import { API_BASE_URL } from '../../config/api';
import { PERMISSION_OPTIONS } from './permissionOptions';

import {
  Drawer,
  Form,
  Input,
  Button,
  Space,
  Checkbox,
  Divider,
} from 'antd';

const defaultPermissions = () =>
  PERMISSION_OPTIONS.reduce((acc, option) => {
    acc[option.key] = 1;
    return acc;
  }, {});

export default class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: '',
      password: '',
      lastName: '',
      firstName: '',
      email: '',
      isClientAdmin: false,
      permissions: defaultPermissions(),
      saving: false,
      errors: [],
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  togglePermission = (key, checked) => {
    this.setState({
      permissions: {
        ...this.state.permissions,
        [key]: checked ? 1 : 0,
      },
    });
  };

  submit = async () => {
    this.setState({
      errors: [],
    });

    let isValid = true;
    let errors = [];

    if (!this.state.firstName) {
      errors.push('First Name is required');
      isValid = false;
    }
    if (!this.state.lastName) {
      errors.push('Last Name is required');
      isValid = false;
    }
    if (!this.state.login) {
      errors.push('Login is required');
      isValid = false;
    }
    if (!this.state.password) {
      errors.push('Password is required');
      isValid = false;
    }

    if (isValid) {
      const token = await authService.ensureValidToken();
      if (!token) {
        console.error('Not authenticated');
        return;
      }

      this.setState({ saving: true });

      axios({
        method: 'POST',
        url: `${API_BASE_URL}/connect/users/`,
        headers: { Authorization: `Bearer ${token}` },
        data: {
          login: this.state.login,
          password: this.state.password,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          clientCode: this.props.client.ClientCode,
          isClientAdmin: this.state.isClientAdmin ? 1 : 0,
          permissions: this.state.permissions,
        },
      }).then(res => {
        toast.success(`User ${this.state.login} was created`);
        this.setState({
          login: '',
          password: '',
          lastName: '',
          firstName: '',
          email: '',
          isClientAdmin: false,
          permissions: defaultPermissions(),
          saving: false,
          errors: [],
        }, () => {
          this.props.loadData();
          this.props.onClose();
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          saving: false,
          errors: [err.response?.data?.error || 'Failed to create user'],
        });
      });
    } else {
      this.setState({
        errors: errors,
      });
    }
  };

  render() {
    const { visible, onClose } = this.props;
    return (
      <Drawer
        title="Add New User"
        onClose={onClose}
        open={visible}
        extra={
          <Space>
            <Button onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" onClick={this.submit} loading={this.state.saving}>
              Save
            </Button>
          </Space>
        }
      >
        <Form
          layout="vertical"
        >
          <Form.Item
            label="First Name"
            rules={[{ required: true, message: 'Please enter first name' }]}
          >
            <Input name="firstName" value={this.state.firstName} onChange={this.handleChange} />
          </Form.Item>

          <Form.Item
            label="Last Name"
            rules={[{ required: true, message: 'Please enter last name' }]}
          >
            <Input name="lastName" value={this.state.lastName} onChange={this.handleChange} />
          </Form.Item>

          <Form.Item
            label="Login"
            rules={[{ required: true, message: 'Please enter login' }]}
          >
            <Input name="login" value={this.state.login} onChange={this.handleChange} />
          </Form.Item>

          <Form.Item
            label="Password"
            rules={[{ required: true, message: 'Please enter password' }]}
          >
            <Input.Password name="password" value={this.state.password} onChange={this.handleChange} />
          </Form.Item>

          <Form.Item label="Email">
            <Input name="email" value={this.state.email} onChange={this.handleChange} />
          </Form.Item>

          <Divider orientation="left" plain>Page Access</Divider>

          {PERMISSION_OPTIONS.map(option => (
            <div key={option.key} style={{ marginBottom: 8 }}>
              <Checkbox
                checked={this.state.permissions[option.key] === 1}
                onChange={(e) => this.togglePermission(option.key, e.target.checked)}
              >
                {option.label}
              </Checkbox>
            </div>
          ))}

          <Divider orientation="left" plain>Administration</Divider>

          <Checkbox
            checked={this.state.isClientAdmin}
            onChange={(e) => this.setState({ isClientAdmin: e.target.checked })}
          >
            Client Administrator (can manage users)
          </Checkbox>
        </Form>
        {this.state.errors.length ?
          <ul>
            {this.state.errors.map((item, index) => <li key={index} style={{ color: 'red' }}>{item}</li>)}
          </ul> : null
        }
      </Drawer>
    );
  }
}
